// extracted by mini-css-extract-plugin
export default {"FilterByTagsWrapper":"FilterByTags_FilterByTagsWrapper__rwqX8"};